import React from 'react';
import ReactPlayer from 'react-player';
import videoInviertaBien from '../images/videos/PresentacionFacebook.mp4';

function VideoPresentacion() {
    return ( 
         <ReactPlayer  controls url = { videoInviertaBien }
            className = 'react-player'
            width = '99%'
            playing={false}
            height = '100%'
            top = '0%' 
        />
    );
}
export default VideoPresentacion;